export interface PermissionNavItem {
  permission: string;
}

export function visibleNavItems<T extends PermissionNavItem>(
  items: T[],
  canView: (permission: string) => boolean,
): T[] {
  return items.filter((item) => canView(item.permission));
}
